import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import BaseSelect from 'shared/components/base/form/base-select'
import BaseTextArea from 'shared/components/base/form/base-text-area'
import {
  setDescription,
  setTopic,
} from 'store/slice/call-detail/call-detail.slice'
import { RootState } from 'store/store'

type PropType = {
  isShowSelectTopic?: boolean
}

const topicOptions = [
  { label: ' ارجاع به بیژن کیامرزی', value: 'ارجاع به بیژن کیامرزی', key: '2' },
]

const CriticismAndOtherSubmissionForm = (prop: PropType) => {
  const { isShowSelectTopic } = prop
  const dispatch = useDispatch()
  const description = useSelector(
    (state: RootState) => state.callDetail.formData.description
  )
  const topic = useSelector(
    (state: RootState) => state.callDetail.formData.topic
  )

  return (
    <>
      {isShowSelectTopic && (
        <>
          <BaseSelect<string>
            label={'انتخاب موضوع'}
            options={topicOptions}
            value={topic || ''}
            className={'w-[11.43rem] text-gray-medium  !font-normal'}
            setInputClassName={() =>
              classNames('text-black text-sm font-normal')
            }
            onSelect={(value: string) => {
              dispatch(setTopic(value))
            }}
          />
          <div className="bg-[#F4F4F6] block h-[0.19rem] my-4  mr-[-0.7rem] ml-[-0.88rem] " />
        </>
      )}

      <div className="grid grid-cols-5">
        <BaseTextArea
          className="col-span-4"
          label="توضیحات"
          rows={6}
          value={description}
          onChange={(event) => {
            if (event.target.value.includes('*')) {
              event.target.value = event.target.value.replace('*', '')
              document.getElementById('search-operator')?.focus()
              return
            }
            dispatch(setDescription(event.target.value))
          }}
        />
      </div>
    </>
  )
}

export default CriticismAndOtherSubmissionForm
